import React from 'react';
import ReactDOM from 'react-dom/client';

import { ApiProvider } from './services/api';
import { getBrowserLocale, I18nProvider, switchLanguage } from './services/i18n';
import { initSentry } from './services/sentry';
import { reloadOnPreloadError } from './services/vite';
import { Router } from './router';

import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/700.css';
import '@fontsource/noto-sans-jp/400.css';
import '@fontsource/noto-sans-jp/500.css';
import '@fontsource/noto-sans-jp/700.css';
import 'simplebar-react/dist/simplebar.min.css';
import './style/index.css';

initSentry();
reloadOnPreloadError();
switchLanguage(getBrowserLocale());

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nProvider>
      <ApiProvider>
        <Router />
      </ApiProvider>
    </I18nProvider>
  </React.StrictMode>
);
